var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/index' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("财务管理")]),_c('el-breadcrumb-item',[_vm._v("抖音美团分帐")])],1),_c('el-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }